var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" testingSub: "+_vm._s(_vm.value)+" "),_c('div',{staticClass:"mt-2"},[_c('b-button',{on:{"click":function($event){return _vm.setValue()}}},[_vm._v("aaa")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }